const translationsJSON = JSON.parse(document.querySelector('#back-in-stock-translations').innerHTML);
const translations = translationsJSON.translations;

document.querySelector("body").addEventListener("click", function (e) {
    if (e.target.matches(".js-back-in-stock")) {
        backInStockFormSubmit(e, false);
    }
});

document.querySelector("body").addEventListener("keyup", function (e) {
    if (e.target.matches("input[name='customer[email]'")) {
        backInStockFormSubmit(e, true);
    }
});

function backInStockFormSubmit(e, keyEvent = false) {
    e.preventDefault();
    e.stopPropagation();

    if (keyEvent && e.key !== 'Enter') {
        return;
    }

    const customerEmail = document.querySelector(".back-in-stock-form input[name='customer[email]']");
    const customerId = document.querySelector(".back-in-stock-form input[name='customer[id]']");
    const productId = document.querySelector(".back-in-stock-form input[name='product[id]']");
    const productSku = document.querySelector(".back-in-stock-form input[name='product[sku]']");
    const lang = document.querySelector(".back-in-stock-form input[name='lang']");

    if (!customerEmail.checkValidity()) {
        handleInvalidEmail();
        return;
    }

    const url = "https://apps.gong-galaxy.com/back-in-stock";
    const data = JSON.stringify({
        "security_token": "8gpXaPBQtw4HwBdriXbsMJhqx8AduX",
        "customer_email": customerEmail.value,
        "customer_id": customerId.value ?? null,
        "product_sku": productSku.value,
        "product_id": productId.value,
        "lang": lang.value
    });

    /*$.ajax({
        url: "https://apps.gong-galaxy.com/back-in-stock",
        data: data,
        method: 'POST',
        crossDomain: true,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        statusCode: {
            201: handle201,
            400: handle400,
            403: handle403,
            422: handle422,
            500: handle500,
        }
    });*/


    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
        body: data,
    })
        .then(response => {
            switch (response.status) {
                case 201:
                    handle201(response);
                    break;
                case 400:
                    handle400(response);
                    break;
                case 403:
                    handle403(response);
                    break;
                case 422:
                    handle422(response);
                    break;
                case 500:
                    handle500(response);
                    break;
                default:
                    console.log("Unhandled status code:", response.status);
            }
        })
        .catch(error => {
            console.error("Error:", error);
        });
}

function displaySuccessResponse(successCode) {
    document.querySelector("#product-back-in-stock").style.display = "none";
    document.querySelector(".back-in-stock-result").innerHTML = "<span class='success'>" + translations.handleSuccess[successCode] + "</span>";
}

function handle201() {
    displaySuccessResponse("201");
}

function displayErrorResponse(errorCode) {
    document.querySelector(".back-in-stock-result").innerHTML = "<span class='error'>" + translations.handleErrors[errorCode] + "</span>";
}

function handle400() {
    displayErrorResponse("400");
}

function handle403() {
    displayErrorResponse("403");
}

function handle422() {
    displayErrorResponse("422");
}

function handle500() {
    displayErrorResponse("500");
}

function handleInvalidEmail() {
    displayErrorResponse("invalid_email");
}
